import { useMemo } from 'react';

import { DASHBOARD_URL, HOWDENS_URL } from 'config';
import { useStatusContext } from 'pages/Status/context';

import { INTRODUCED_TITLE, LINE_1, SUBTITLE_ARRAY, TITLE } from './constants';

import { PROVIDERS } from '../../../Lenders/constants';

export interface FinishedHook {
  title: string;
  subtitleArray: string[];
  line1: string[];
  email: string;
  phone: string;
  hours?: string[];
  isExampleJob: boolean;
  jobId?: string;
  exampleReturnUrl: string;
  isIntroduced: boolean;
}

export default function useFinished(): FinishedHook {
  const {
    job,
    provider: statusProvider,
    jobCompanyInfo,
    isLoading,
    isExampleJob,
    isIntroduced,
    isDeliveryOnly,
  } = useStatusContext();

  const companyName = useMemo(() => {
    if (!jobCompanyInfo || isLoading) return 'Your tradesperson';
    return jobCompanyInfo?.company_name || 'Your tradesperson';
  }, [jobCompanyInfo, isLoading]);

  const title = useMemo(() => {
    if (isIntroduced || isDeliveryOnly) return INTRODUCED_TITLE;
    return TITLE;
  }, [isIntroduced, isDeliveryOnly]);

  const subtitleArray = useMemo(
    () => SUBTITLE_ARRAY.map((part) => part.replace('$partner', companyName)),
    [companyName],
  );

  const provider = useMemo(() => {
    if (!statusProvider) return PROVIDERS.demo;
    if (statusProvider === 'example') return PROVIDERS.demo;
    return PROVIDERS[statusProvider];
  }, [statusProvider]);

  const line1 = useMemo(
    () =>
      LINE_1.map((part) =>
        part.replace('$lender', provider.name ?? 'your lender'),
      ),
    [provider],
  );

  const jobId = useMemo(() => job?.id, [job]);

  const exampleReturnUrl = useMemo(() => {
    if (!job?.introduced_to) return `${DASHBOARD_URL}/job-details/${jobId}`;
    return `${HOWDENS_URL}/job/${jobId}`;
  }, [jobId, job]);

  return {
    title,
    subtitleArray,
    line1,
    email: provider.contact.email,
    phone: provider.contact.phone,
    hours: provider.contact?.hours,
    isExampleJob,
    jobId,
    exampleReturnUrl,
    isIntroduced,
  };
}
